export const LAUNCH_AT = Date.parse("2026-12-23T13:00:00Z");

const override = () => {
  if (process.env.REACT_APP_ALLOW_CLOCK_OVERRIDE !== "true") return 0;
  const param = new URLSearchParams(window.location.search).get("now");
  const t = param ? Date.parse(param) : NaN;
  return Number.isNaN(t) ? 0 : t - Date.now();
};

const OFFSET = override();

export const now = () => Date.now() + OFFSET;
